// extracted by mini-css-extract-plugin
export default {"dictionary":"Dictionary_dictionary__mfibP","dictionary__word":"Dictionary_dictionary__word__E3BhM","dictionary__translate":"Dictionary_dictionary__translate__hJvjg"};